import React from 'react';
import { Wallet } from 'lucide-react';
import { fmtInt, fmtUSD } from './starFormat';
import { ObsidianCard } from './StarBits';

const Pod = ({ label, value, sub, testId, tone }) => (
  <div data-testid={testId}
    className={`rounded-2xl border p-3 backdrop-blur-md ${tone === 'emerald'
      ? 'border-emerald-400/25 bg-emerald-400/[0.07]'
      : tone === 'gold' ? 'border-amber-400/20 bg-amber-400/[0.06]'
        : 'border-white/[0.07] bg-white/[0.04]'}`}>
    <p className="text-[9px] font-bold uppercase tracking-[0.16em] text-zinc-500">{label}</p>
    <p className={`mt-1 font-mono text-base font-black leading-tight sm:text-lg ${
      tone === 'emerald' ? 'text-emerald-300' : tone === 'gold' ? 'text-amber-300' : 'text-white'}`}>
      {value}
    </p>
    {sub && <p className="mt-0.5 font-mono text-[10px] text-zinc-500">{sub}</p>}
  </div>
);

export const HostCycleEarnings = ({ earnings }) => {
  const e = earnings;
  return (
    <ObsidianCard testId="host-cycle-earnings-card" className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-1">
        <p className="flex items-center gap-2 font-display text-sm font-bold text-white">
          <Wallet className="h-4 w-4 text-emerald-400" /> Seus ganhos neste ciclo
        </p>
        <span className="text-[10px] text-zinc-500">já creditado · sem projeção</span>
      </div>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
        <Pod testId="host-earnings-commission" label="Comissão do ciclo"
          value={`${fmtInt(e.commission_crystals)} cristais`} sub={fmtUSD(e.commission_usd)} />
        <Pod testId="host-earnings-bonus" label="Bônus diário acumulado" tone="gold"
          value={`${fmtInt(e.bonus_crystals)} cristais`}
          sub={`${fmtUSD(e.bonus_usd)}${e.daily_bonus_usd ? ` · US$ ${e.daily_bonus_usd},00 por dia` : ''}`} />
        <Pod testId="host-earnings-total" label="Total do ciclo" tone="emerald"
          value={`${fmtInt(e.total_crystals)} cristais`} sub={fmtUSD(e.total_usd)} />
      </div>
    </ObsidianCard>
  );
};
